import React from 'react';

type Props = {
  activeStepIndex?: number;
  stepIndex?: number;
  children: React.ReactNode;

  stepId?: string;
  activeStepId?: string;
};

const isDefined = (value: any) => value !== undefined;

export const StepContent: React.FC<Props> = ({
  activeStepIndex,
  stepIndex,

  stepId,
  activeStepId,
  children
}) => {
  // Component used with Step ID
  if (isDefined(activeStepId) && isDefined(stepId)) {
    if (activeStepId === stepId) return <>{children}</>;
  }

  // Component used with Step Index
  if (isDefined(activeStepIndex) && isDefined(stepIndex)) {
    if (activeStepIndex === stepIndex) return <>{children}</>;
  }

  return null;
};
